// eslint-disable-next-line unicorn/filename-case
import React from "react";
import { graphql } from "gatsby";
import ArchiveTemplate from "./articlesTemplate";

const ArticlesCategory = (props) => {
  const { pageContext } = props;
  const { nodes } = props.data.allWpPost;
  return (
    <ArchiveTemplate
      cat={pageContext.cat}
      archivePath={pageContext.archivePath}
      nodes={nodes}
      cats={pageContext.cats}
      nextPath={pageContext.nextPath}
      previousPath={props.pageContext.previousPath}
    />
  );
};
export default ArticlesCategory;

export const pageQuery = graphql`
  query ArticleCategoryQuery($cat: String!, $skip: Int!, $limit: Int!) {
    allWpPost(
      filter: { categories: { nodes: { elemMatch: { name: { eq: $cat } } } } }
      sort: {date: DESC}
      skip: $skip
      limit: $limit
    ) {
      nodes {
        id
        title
        excerpt
        author {
          node {
            name
            slug
            description
            avatarImg {
              childImageSharp {
                tiny: gatsbyImageData(width: 100, placeholder: BLURRED, layout: FIXED)
              }
            }
          }
        }
        featuredImage {
          node {
            sourceUrl
            altText
            localFile {
              childImageSharp {
                archive: gatsbyImageData(width: 200, placeholder: BLURRED, layout: CONSTRAINED)
              }
            }
          }
        }
        categories {
          nodes {
            name
            slug
          }
        }
        date(formatString: "LL")
        slug
      }
    }
  }
`;
